const strings = {
  interationFarmer: {
    title: 'Interação com o Agricultor',
  },
}

export default strings
